<template>
    <list-page
        page-title="Items"
        page-icon="mdi-format-list-bulleted"
        collection-name="item"
        :items-per-page="20"
        add-dialog-title="Add Item"
        is-filter
    />
</template>

<script>
import ListPage from '../../../components/pages/List';

export default {
    name: 'ItemList',
    components: { ListPage },
};
</script>

<style scoped></style>
